import React, { useMemo, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Button,
  MenuItem,
  Select,
  Modal,
  Backdrop,
  Fade,
  CircularProgress,
} from '@material-ui/core';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import FileSelect from '../../components/FileSelect/FileSelect';
import { optionStyles } from './styles';
import Error from '../../assets/remove.svg';
import Success from '../../assets/Success.svg';

import api from '../../services/api';
import axios from 'axios';

interface FormData {
  file: File;
  // file2: File;
}
interface SamuFormData {
  fileSamu: File;
}

interface ImporterResponseBody {
  task_id: string;
  status: string;
  mensagem: string;
}

interface ImporterStatusResponseBody {
  erro: boolean;
  result: {
    task_id: string;
    mensagem: string;
  };
  status: string;
}

const Importer: React.FC = () => {
  const classes = optionStyles();

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);
  const [dataset, setDataset] = useState(1);
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });
  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [openError, setOpenError] = useState(false);
  const [openMissingDetails, setMissingDetails] = useState(false);
  const [openSuccess, setSuccess] = useState(false);
  const [taskStatus, setTaskStatus] = useState<string>('');
  const history = useHistory();

  const handleCloseError = () => {
    setOpenError(false);
  };
  const handleCloseMissingDetails = () => {
    setMissingDetails(false);
  };
  const handleCloseSuccess = () => {
    setSuccess(false);
    history.push('/mapa/sinistros');
  };

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  if ((tecEng || geofi || publicGroup) && !(admin || typist)) {
    history.push('/mapa/sinistros');
  }
  const handleFormSamuSubmit: SubmitHandler<SamuFormData> = async (
    data: SamuFormData,
  ) => {
    if (data.fileSamu === undefined) {
      setMissingDetails(true);
    } else {
      if (data.fileSamu.size / 1000 >= 200000) {
        setLoading(false);
        setSnackbar({
          open: true,
          message: 'O tamanho dos arquivos não pode ultrapassar 200MB!',
        });
        return;
      }
      setLoading(true);

      api
        .post(`/api/samu_records/`, data.fileSamu, {
          headers: {
            'Content-Type': `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            ...authHeader,
          },
        })
        .then(async (response) => {
          console.log('SamuImport Response:', response.data);
          setLoading(false);
          setSnackbar({
            open: true,
            message:
              'A importação dos registros foi iniciada com sucesso! O processo pode demorar até 10 minutos para completar!',
          });
        })
        .catch((err) => {
          console.log('SamuImport error:', err);
          setLoading(false);
          setSnackbar({
            open: true,
            message: 'Ocorreu um erro ao tentar importar os arquivos',
          });
        });
    }
  };

  const handleSubmit: SubmitHandler<FormData> = async (data: FormData) => {
    if (data.file === undefined) {
      setMissingDetails(true);
    } else {
      if (data.file.size / 1000 >= 200000) {
        setLoading(false);
        setSnackbar({
          open: true,
          message: 'O tamanho dos arquivos não pode ultrapassar 200MB!',
        });
        return;
      }
      setLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append('file', data.file);
      api
        .post<ImporterResponseBody>('/api/importer/importer_prf_csv/', bodyFormData, {
          headers: {
            ...authHeader,
          },
        })
        .then(async (response) => {
          setLoading(false);
          setSnackbar({
            open: true,
            message:
              'A importação dos registros foi iniciada com sucesso! O processo pode demorar até 10 minutos para completar!',
          });
        })
        .catch((err) => {
          setLoading(false);
          setSnackbar({
            open: true,
            message: 'Ocorreu um erro ao tentar importar os arquivos',
          });
        });
    }
  };

  return (
    <>
      <Container maxWidth="xl" className={classes.root}>
        <Card>
          <CardHeader
            className={classes.cardHeader}
            title="Importador de base"
            titleTypographyProps={{ style: { fontSize: 20 } }}
          />
          <CardContent className={classes.cardContent}>
            {loading ? (
              <div className={classes.loadingContainer}>
                <CircularProgress
                  className={classes.loadingSpinner}
                  size={60}
                  thickness={5}
                />
              </div>
            ) : (
              <>
                <Form ref={formRef} onSubmit={handleSubmit}>
                  <FileSelect name="CSV PRF" nameInput="file" />
                  {/* <FileSelect name="CSV Auxiliar" nameInput="file2" /> */}
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                  >
                    Enviar
                  </Button>
                </Form>

                <Form style={{ marginTop: '1rem' }} onSubmit={handleFormSamuSubmit}>
                  <FileSelect name="XLSX Samu" nameInput="fileSamu" />
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                  >
                    Enviar
                  </Button>
                </Form>
              </>
            )}
          </CardContent>
        </Card>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openError}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openError}>
            <div className={classes.paper}>
              <img src={Error} alt="Não foi possível importar." width="50" />
              <p id="transition-modal-description">
                Não foi possível importar o arquivo.
              </p>
              <Button className={classes.button} onClick={() => handleCloseError()}>
                Ok
              </Button>
            </div>
          </Fade>
        </Modal>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openMissingDetails}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openMissingDetails}>
            <div className={classes.paper}>
              <img src={Error} alt="Não foi possível importar." width="50" />
              <p id="transition-modal-description">
                Selecione os arquivos para importar.
              </p>
              <Button
                className={classes.button}
                onClick={() => handleCloseMissingDetails()}
              >
                Ok
              </Button>
            </div>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openSuccess}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openSuccess}>
            <div className={classes.paper}>
              <img src={Success} alt="Sucesso ao importar." width="50" />
              <p id="transition-modal-description">Importação concluída com sucesso!</p>
              <Button className={classes.button} onClick={() => handleCloseSuccess()}>
                Ok
              </Button>
            </div>
          </Fade>
        </Modal>
        <ShowSnackbar
          open={snackBar.open}
          message={snackBar.message}
          setSnackbar={setSnackbar}
        />
      </Container>
    </>
  );
};

export default Importer;
